import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {
  useEffect,
  useState,
} from 'react';
import styled from 'styled-components';
import {
  Avatar,
  Button,
  Card,
  Modal,
} from 'antd';

import i18n from '../../config/i18n';

import defaultTestimonialAvatarImage from '../../styles/images/no_testimonial_avatar_image.png';

/**
 * Override 'antd-card-meta-title' style to show the whole title.
 *  overflow: initial;
 *  white-space: initial;
 */
const H4 = styled.h4`
  color: #2C3E50;
  fon-size: 18px;
  font-weight: 700;
  text-align: center;
  overflow: initial;
  white-space: initial;
`;

const P = styled.p`
  color: #87A6C6;
  font-size: 15px;
  margin: 0;
  text-align: center;
`;

const styles = {
  avatar: { margin: 'auto' },
  inList: {
    border: '2px solid #6AE2CE',
    marginBottom: '30px',
    paddingTop: '15px',
  },
  inModal: {
    border: '2px solid #6AE2CE',
    height: '100%',
    padding: '15px',
  },
  body: {
    marginTop: '15px',
    padding: '0',
  },
  meta: {
    overflow: 'hidden',
    height: '180px',
    marginBottom: '-72px',
  },
  button: {
    width: '100%',
    height: '72px',
    border: 'none',
    background: 'linear-gradient(rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)',
    paddingTop: '36px',
    fontWeight: 'bold',
  },
};

const cardType = {
  IN_LIST: 'inlist',
  IN_MODAL: 'inModal',
};

/*
 * NOTE: when new user register, his/her default medicalGroup and specialty
 * won't be set initially.
 */
const PublicTestimonialSectionItem = ({
  getPhotoDownloadURLCallback,
  medicalGroup,
  specialty,
  testimonial: {
    description,
    id,
    user: {
      firstName,
      lastName,
    },
    websiteURL,
  },
}) => {
  const [avatarUrl, setAvatarUrl] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const medicalGroupName = _.isEmpty(medicalGroup) ? '' : medicalGroup.name;
  const specialtyName = _.isEmpty(specialty) ? '' : specialty.name;

  const init = async () => {
    const result = await getPhotoDownloadURLCallback(`testimonials/${id}/avatar`);
    if (!result.message) {
      setAvatarUrl(result);
    }
  };

  useEffect(() => {
    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Generate in-list card or in-modal card.
  const genCard = (type) => {
    const isInList = type === cardType.IN_LIST;
    return (
      <Card
        cover={
          <Avatar
            alt={i18n.t('testimonialAvatar')}
            size={200}
            src={defaultTestimonialAvatarImage}
            srcSet={avatarUrl}
            style={styles.avatar}
          />
        }
        style={isInList ? styles.inList : styles.inModal}
        bodyStyle={styles.body}
      >
        <Card.Meta
          title={
            <H4>{firstName} {lastName}</H4>
          }
          description={
            <div>
              <P>{specialtyName}</P>
              <P>
                {
                  websiteURL ? (
                    <a
                      href={websiteURL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {medicalGroupName}
                    </a>
                  ) : medicalGroupName
                }
              </P>
              {
                description && (
                  <P>{`"${description}"`}</P>
                )
              }
            </div>
          }
          style={isInList ? styles.meta : {}}
        />
        {
          isInList && (
            <Button
              type="link"
              style={styles.button}
              onClick={() => {
                setModalVisible(true);
              }}
            >
              {i18n.t('readMore')}
            </Button>
          )
        }
      </Card>
    );
  };

  return (
    <div>
      {genCard(cardType.IN_LIST)}
      <Modal
        closable={false}
        footer={null}
        onCancel={() => { setModalVisible(false); }}
        visible={modalVisible}
      >
        {genCard(cardType.IN_MODAL)}
      </Modal>
    </div>
  );
};

const metadataShape = PropTypes.shape({
  id: PropTypes.number,
  code: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string,
});

PublicTestimonialSectionItem.propTypes = {
  testimonial: PropTypes.shape({
    id: PropTypes.number.isRequired,
    websiteURL: PropTypes.string,
    user: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
    }),
  }),
  medicalGroup: metadataShape,
  specialty: metadataShape,
  getPhotoDownloadURLCallback: PropTypes.func.isRequired,
};

PublicTestimonialSectionItem.defaultProps = {
  testimonial: {},
  medicalGroup: {},
  specialty: {},
};


export default PublicTestimonialSectionItem;



// WEBPACK FOOTER //
// ./src/components/testimonial/PublicTestimonialSectionItem.js